import script from "./bulk-tags-button.vue?vue&type=script&setup=true&lang=js"
export * from "./bulk-tags-button.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__